// ApplicationsService.ts
import axios from 'axios';
import { axiosRequest } from '../AxiosService';
import { ApplicationsResponseList,ApplicationsResponse} from '../../type/response/ApplicationsResponse';  
import { ApplicationType } from '../../pages/HomePage/Components/ApplicationSelect/ApplicationType ';

/**
 * ホームページ用の申請種別・申請書一覧データを取得し、表示用の形式に変換して返す
 * @returns 申請種別一覧データ、取得失敗時は空配列
 */
export const getApplications = async (): Promise<ApplicationType[]> => {
  try {
    const response = await axiosRequest<ApplicationsResponseList>(
      "/applications", 
      "GET"
    );

    // 取得したデータのフォーマット化
    const formattedApplications: ApplicationType[] = response.map((applicationResponse: ApplicationsResponse) => {
      const formattedApplication: ApplicationType = {
        id: applicationResponse.applicationType.id,
        type: applicationResponse.applicationType.name, // 申請種別名
        theme: {
          id: applicationResponse.theme.id,
          icon: {
            name: applicationResponse.theme.iconName, // icon 名称
            color: applicationResponse.theme.iconColor, // icon色
            backgroundColor: applicationResponse.theme.iconBgColor, // icon背景色
            borderColor: applicationResponse.theme.iconBorderColor, // icon枠線色
          },
          buttons: {
            color: applicationResponse.theme.buttonColor, // button色
            fontColor: applicationResponse.theme.buttonFontColor, // button文字色
            borderColor: applicationResponse.theme.buttonBorderColor, // button枠線色
          },
        },
        applications: applicationResponse.applications.map((app) => ({
          id: app.id,
          name: app.name, // 申請書名
          description: app.description
        }))
      };

      return formattedApplication;
    });

    return formattedApplications;

  } catch (error) {
    console.error("申請データの取得・整形に失敗しました:", error);
    return []; 
  }
};